module.exports = __webpack_public_path__ + "static/blue-shapes-e2107110906a47b507d944083dae7c49.jpg";